<template>
  <button
      v-if="offset"
      class="btn"
      @click.prevent="handlePrevButtonClick"
  >Prev
  </button>
</template>

<script>
export default {
  props: ['offset', 'limit'],
  name: "FootprintTablePrevButton",
  methods: {
    handlePrevButtonClick() {
      this.offset && this.$emit('on-prev-button-click', this.offset - 10)
    }
  }
}
</script>

<style scoped>

</style>